import {
	REQUEST_GROUPS,
	RECEIVE_GROUPS,
	RECEIVE_GROUPS_ERROR,
	REQUEST_ADD_GROUP,
	RECEIVE_ADD_GROUP,
	ADD_GROUP_ERROR,
	REQUEST_DELETE_GROUP,
	RECEIVE_DELETE_GROUP,
	DELETE_GROUP_ERROR,
	REQUEST_UPDATE_GROUP,
	RECEIVE_UPDATE_GROUP,
	UPDATE_GROUP_ERROR,
	RECEIVE_WINDOWS_ERROR,
	RECEIVE_QUERY_WINDOWS,
	REQUEST_QUERY_WINDOWS,
} from "../actions/groupActionsRedux";

import { RECEIVE_DELETE_USER } from "../actions/userActionsRedux";

import { RECEIVE_LOGOUT_USER } from "../actions/activeUserActions";

const initialGroupState = {
	isFetching: false,
	items: [],
	error: null,
	ldapQuery: [],
};

export const groupReducer = (state = initialGroupState, action) => {
	switch (action.type) {
		case REQUEST_GROUPS:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_GROUPS:
			//sets new state and fetching ended
			return { ...state, items: action.payload, isFetching: false, error: null };
		case RECEIVE_GROUPS_ERROR:
			//fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case REQUEST_ADD_GROUP:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_ADD_GROUP:
			//sets new state and fetching ended
			return { ...state, items: [...state.items, action.payload], isFetching: false, error: null };
		case ADD_GROUP_ERROR:
			//fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case REQUEST_DELETE_GROUP:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_DELETE_GROUP:
			//filters the groups that have been removed
			const newItems = state.items.filter(item => item._id !== action.payload._id);
			return { ...state, items: newItems, isFetching: false, error: null };
		case DELETE_GROUP_ERROR:
			//fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case REQUEST_UPDATE_GROUP:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_UPDATE_GROUP:
			//filters the groups that have not been changed and replaces them with the new payload
			const newGroups = state.items.map(item => (item._id === action.payload._id ? action.payload : item));
			return { ...state, items: newGroups, isFetching: false, error: null };
		case UPDATE_GROUP_ERROR:
			//fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case REQUEST_QUERY_WINDOWS:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_QUERY_WINDOWS:
			//sets new state and fetching ended
			return { ...state, ldapQuery: action.payload, isFetching: false, error: null };
		case RECEIVE_WINDOWS_ERROR:
			//fetching ended and error is being set
			return { ...state, ldapQuery: [], error: action.payload, isFetching: false };
		case RECEIVE_DELETE_USER:
			//fetching ended and error is being set
			const removedUser = action.payload;
			const newItemsAfterUserDelete = state.items.map(item => {
				if (removedUser.groups.includes(item._id)) {
					const index = item.members.indexOf(removedUser._id);
					item.members.splice(index, 1);
				}
				return item;
			});
			return { ...state, items: newItemsAfterUserDelete, isFetching: false };
		case RECEIVE_LOGOUT_USER:
			//sets new state and fetching ended
			return { ...initialGroupState, isFetching: false };
		default:
			return state;
	}
};
